/**
 * Notes Section Component
 * Collapsible notes section with unified styling
 */

import React from 'react';
import Text from '@amzn/meridian/text';
import NotesDisplay from './NotesDisplay';
import NoteEditor from './NoteEditor';

interface NotesSectionProps {
  sessionId: string;
  onClose?: () => void;
  /** False greys out the Add Note editor. Editing an existing note is already restricted to
   *  its author inside NotesDisplay. */
  canEdit?: boolean;
}

const NotesSection: React.FC<NotesSectionProps> = ({ sessionId, onClose, canEdit = true }) => {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Content - Scrollable notes list */}
      <div style={{ 
        flex: 1,
        minHeight: 0,
        padding: '12px',
        overflowY: 'auto',
      }}>
        <NotesDisplay sessionId={sessionId} />
      </div>

      {/* Footer - Add Note (always at bottom) */}
      <div style={{
        padding: '20px 24px',
        borderTop: '1px #ccc',
        backgroundColor: '#f8f8f8',
        flexShrink: 0,
      }}>
        <div style={{ marginBottom: '12px' }}>
          <Text type="b500"><strong>Add Note</strong></Text>
        </div>
        <NoteEditor sessionId={sessionId} disabled={!canEdit} />
      </div>
    </div>
  );
};

export default NotesSection;
